import { UserNotificationDTO } from 'src/services/generated/api.generated.v1';

export interface UserVehicle {
  vin: string;
  uid: string;
  displayName: string;
  permissions: Array<string>;
  isActive: boolean;
}

export interface UserStateInterface {
  id: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  zipCode: string | null;
  permissions: Array<string>;
  vehicles: Array<UserVehicle>;
  termsAndConditionsAccepted: boolean;
  notifications: Array<UserNotificationDTO>;
  rememberUsername: boolean;
  username: string | null;
  allowPushNotifications: boolean;
}

function state(): UserStateInterface {
  return {
    id : null,
    email: null,
    firstName: null,
    lastName: null,
    zipCode: null,
    permissions: [],
    vehicles: [],
    termsAndConditionsAccepted: false,
    notifications: [],
    rememberUsername: false,
    username: null,
    allowPushNotifications: false
  }
}

export default state;
